/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from 'react';

const CustomCheckbox = forwardRef(({ onClick, ...rest }, ref) => (
  <div className="custom-control custom-control-sm custom-checkbox notext">
    <input
      id={rest.name}
      type="checkbox"
      className="custom-control-input form-control"
      ref={ref}
      onClick={onClick}
      {...rest}
    />
    <label className="custom-control-label" htmlFor={rest.name} />
  </div>
));

CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox;
